// router/modules/personal.ts
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'personal',
    name: 'Personal',
    component: () => import('@/views/personal/index.vue'),
    redirect: '/personal/material',
    children: [
      // 资料信息
      {
        path: 'material',
        name: 'Material',
        component: () => import('@/views/personal/material/index.vue'),
        redirect: '/personal/material/profile',
        children: [
          {
            path: 'profile',
            name: 'Profile',
            component: () =>
              import('@/views/personal/material/profile/index.vue')
          },
          {
            path: 'profile/verification',
            name: 'Verification',
            meta: { hideFromMenu: true, title: '实名认证' },
            component: () =>
              import('@/views/personal/material/profile/verification/index.vue')
          },
          {
            path: 'freshman',
            name: 'Freshman',
            component: () =>
              import('@/views/personal/material/freshman/index.vue')
          },
          {
            path: 'freshman/record',
            name: 'FreshmanRecord',
            meta: { hideFromMenu: true, title: '新生报道记录' },
            component: () =>
              import('@/views/personal/material/freshman/record/index.vue')
          },
          {
            path: 'freshman/apply',
            name: 'FreshmanApply',
            meta: { hideFromMenu: true, title: '新生报道申请' },
            component: () =>
              import('@/views/personal/material/freshman/apply/index.vue')
          },
          {
            path: 'academic',
            name: 'Academic',
            component: () =>
              import('@/views/personal/material/academic/index.vue')
          },
          {
            path: 'examination',
            name: 'Examination',
            component: () =>
              import('@/views/personal/material/examination/index.vue')
          }
        ]
      },

      // 学习工具
      {
        path: 'learn',
        name: 'Learn',
        component: () => import('@/views/personal/learn/index.vue'),
        redirect: '/personal/learn/course',
        children: [
          {
            path: 'record',
            name: 'record',
            component: () => import('@/views/personal/learn/record/index.vue')
          },
          {
            path: 'course',
            name: 'Course',
            component: () => import('@/views/personal/learn/course/index.vue')
          },
          {
            path: 'history',
            name: 'History',
            component: () => import('@/views/personal/learn/history/index.vue')
          },
          {
            path: 'thesis',
            name: 'Thesis',
            component: () => import('@/views/personal/learn/thesis/index.vue')
          },
          {
            path: 'degree',
            name: 'Degree',
            component: () => import('@/views/personal/learn/degree/index.vue')
          }
        ]
      },
      // 考试工具
      {
        path: 'examTool',
        name: 'examTool',
        component: () => import('@/views/personal/examTool/index.vue'),
        redirect: '/personal/examTool/examRecord',
        children: [
          {
            path: 'examRecord',
            name: 'examRecord',
            component: () =>
              import('@/views/personal/examTool/examRecord/index.vue')
          },
          {
            path: 'examAnswer',
            name: 'examAnswer',
            component: () =>
              import('@/views/personal/examTool/examAnswer/index.vue')
          }
        ]
      },
      {
        path: 'orders',
        name: 'orders',
        component: () => import('@/views/personal/shop/orders/index.vue')
      },
      {
        path: 'orders/detail',
        name: 'ordersDetail',
        meta: { hideFromMenu: true, title: '订单详情' },
        component: () => import('@/views/personal/shop/orders/detail/index.vue')
      },
      // 消息中心
      {
        path: 'others',
        name: 'Others',
        component: () => import('@/views/personal/others/index.vue'),
        redirect: '/personal/others/message',
        children: [
          {
            path: 'message',
            name: 'Message',
            component: () => import('@/views/personal/others/message/index.vue')
          }
        ]
      }
    ]
  }
]

export default routes
